<template>
  <AppView
    padd-bottom
  >

    <template v-slot:top-app-view>
      <transition name="fade" mode="out-in" appear>
        <CompanyHeader :company="company" :loading="loadingCompany" />
      </transition>
    </template>

    <transition name="fade" mode="out-in" appear>

      <div v-if="errorCompany || error" class="tw-mt-12" key="errmsg">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorCompany"></p>
      </div>

      <div v-else-if="loadingCompany || loading" class="tw-mt-12" key="lodng">
        <p class="tw-py-12 tw-text-base tw-text-center">Loading...</p>
      </div>

      <div v-else key="bdy">
        <transition name="fade" mode="out-in" appear>
          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">
              <div class="tw-flex tw-items-center">
                <UserPhoto
                  :photo="activeCompanyProgram.logo"
                  :user-name="{
                    name: activeCompanyProgram.name,
                  }"
                  logo
                  photo-size="tw-h-10 tw-w-10"
                  :class="[
                    'tw-rounded-10--force --force-children tw-bg-app-white-87 tw-mx-2',
                    { 'tw-shadow-app-sm': !(activeCompanyProgram.logo || '').length }
                  ]"
                />

                <p class="tw-font-bold">
                  {{ activeCompanyProgram.name }} Mentorship Program
                </p>
              </div>
              <div class="tw-flex tw-justify-between">
                <div>
                  <h3 class="tw-text-2xl">Survey Responses</h3>
                  <h5 class="tw-text-base">Survey name: <span class="tw-font-bold">{{surveyType.name}}</span></h5>
                </div>
                <div>
                  <BaseButton
                    :text="reportBtnText"
                    class="tw-border-none tw-font-bold hover:tw-shadow-app transition-fast tw-bg-app-deep-blue-11 tw-block tw-py-3 tw-px-6 tw-mr-4"
                    :disabled="disabledReportBtn"
                    @click="generateReport()"
                  />
                </div>
              </div>
              <div class="tw-border-t tw-border-app-black-11 tw-my-6"></div>

              <template v-for="(questionWithResponses, index) in questionsWithResponses">
                <div :key="index" class="tw-rounded-10 tw-bg-gray-200 tw-mb-3 tw-p-4">
                  <p class="tw-text-lg tw-mb-4">{{questionWithResponses.question}} ({{questionWithResponses.type.q_type}})</p>
                  <template v-if="!questionWithResponses.responses.length">
                    <p class="tw-text-center tw-p-5 opacity-54 tw-bg-gray-300 tw-rounded-10">0 responses</p>
                  </template>
                  <template v-else>
                    <p>Responses</p>
                    <template v-if="questionWithResponses.type.q_type === 'Ratings'">
                      <div style="height: 250px; width: 250px;" class="tw-relative">
                        <PieChart
                          :data="[
                            ...Object.values(questionWithResponses.data).map(d => d.counts || 0),
                          ]"
                          :data-labels="[
                            ...Object.values(questionWithResponses.data).map(d => `${d.label} (${d.countPercentage})`),
                          ]"
                          :data-colors="[
                            '#000000',
                            '#EDA310',
                            '#E96B6B',
                            'rgba(237, 163, 16, 0.11)',
                            '#B2967D',
                            '#98C9A3'
                          ]"
                          :height="250"
                          :width="250"
                        />
                      </div>
                    </template>
                    <template v-else-if="questionWithResponses.type.q_type === 'Choices'">
                      <ol class="tw-bg-gray-300 tw-p-3 tw-rounded-10">
                        <ViewMore
                          :limit="6"
                          :list="Object.values(questionWithResponses.userChoices)"
                          v-slot="{ item: userChoices }"
                        >
                          <li
                            v-if="userChoices.choices.length"
                            :key="userChoices.userName"
                            class="tw-border-b tw-border-gray-400 tw-py-2 tw-text-sm tw-flex tw-items-start"
                          >
                            <span class="tw-mr-1">{{userChoices.userName}} : </span>
                            <span>
                              <span
                                v-for="choice in userChoices.choices"
                                :key="choice.id"
                              >
                                - {{choice.ratings}} <br />
                              </span>
                            </span>
                          </li>
                        </ViewMore>
                      </ol>
                    </template>
                    <template v-else>
                      <ol class="tw-bg-gray-300 tw-p-3 tw-rounded-10">
                        <ViewMore
                          :limit="6"
                          :list="questionWithResponses.responses"
                          v-slot="{ item: response }"
                        >
                          <li
                            v-if="response.response.length"
                            :key="response.id"
                            class="tw-border-b tw-border-gray-400 tw-py-2 tw-text-sm"
                          >
                            <span>{{response.user.name}} {{response.user.last_name}} : </span> {{response.response}}
                          </li>
                        </ViewMore>
                      </ol>
                    </template>
                  </template>
                </div>
              </template>

            </div>
          </div>
        </transition>
      </div>
    </transition>
  </AppView>
</template>

<script>
import CompanyHeader from '@/views/Companies/Company/_partials/CompanyHeader.vue';
import PieChart from '@/components/PieChart.vue';
import UserPhoto from '@/components/UserPhoto.vue';
import companyProgramMixin from '@/mixins/companyProgram';
import companyMixin from '@/mixins/company';
import reportMixin from '@/mixins/report';
import xlsx from 'json-as-xlsx';

export default {
  name: 'CompanyProgramSurveyResponses',
  components: {
    CompanyHeader,
    PieChart,
    UserPhoto,
  },
  mixins: [companyMixin, reportMixin, companyProgramMixin],
  props: ['id', 'programId', 'questionTypeId'],
  data() {
    return {
      error: undefined,
      loading: true,
      surveyType: {},
      questionsWithResponses: [],
    };
  },
  methods: {
    async getSurvey() {
      const surveyTypes = await this.$store.dispatch('getProgramSurveyTypes', [this.activeCompanyProgram.id, true]);

      if (!Array.isArray(surveyTypes)) {
        this.error = 'Could not get Survey';
        return;
      }

      this.surveyType = surveyTypes.find((type) => Number(type.id) === Number(this.questionTypeId));
    },
    // gets the questions and the responses and the users
    async getSurveyResponses() {
      const questionsWithResponses = await this.$store.dispatch('getCompanyProgramSurveyResponses', [this.activeCompanyProgram.id, this.questionTypeId]);

      if (!Array.isArray(questionsWithResponses)) {
        this.error = 'could not get survey questions with responses';
        return false;
      }

      // transform to piechart data
      const labels = [];
      const transformedData = questionsWithResponses.map((questionWithResponses) => {
        const data = {};
        const dataWithPercentageCounts = {};
        let totalCounts = 0;

        questionWithResponses.responses.forEach((response) => {
          if (questionWithResponses.type.q_type === 'Ratings') {
            // find the rate id
            const rate = questionWithResponses.ratings.find((rating) => Number(rating.id) === Number(response.rateid));

            // console.log(rate, response);
            if (!labels.includes(rate.ratings)) {
              labels.push(rate.ratings);
            }
            const dataKey = `${rate.ratings}/${rate.id}`;

            data[dataKey] = {
              label: rate.ratings,
              counts: (data[dataKey]?.counts || 0) + 1,
            };

            totalCounts += 1;
          } else if (questionWithResponses.type.q_type === 'Choices') {
            // Add user choices to questionWithResponses
            if (!questionWithResponses.userChoices) {
              questionWithResponses.userChoices = {};
            }
            if (!questionWithResponses.userChoices[response.user.id]) {
              questionWithResponses.userChoices[response.user.id] = {
                userName: `${response.user.name} ${response.user.last_name}`,
                choices: []
              };
            }
            const theChoice = questionWithResponses.ratings.find((choice) => Number(choice.id) === Number(response.rateid));
            questionWithResponses.userChoices[response.user.id].choices.push(theChoice);
          }
        });

        // calculate percentage
        Object.entries(data).forEach(([key, d]) => {
          const percentage = ((d.counts * 100) / totalCounts).toFixed(1);

          dataWithPercentageCounts[key] = {
            ...d,
            label: d.label,
            countPercentage: `${percentage}%`,
          };
        });

        return {
          ...questionWithResponses,
          data: dataWithPercentageCounts,
        };
      });

      // console.log(transformedData);

      this.questionsWithResponses = transformedData;

      return true;
    },
    async getPageData() {
      this.loading = true;
      this.error = undefined;

      await Promise.all([
        this.getSurvey(),
        this.getSurveyResponses(),
      ]);

      this.loading = false;
    },
    async generateReport() {
      this.disabledReportBtn = true;
      this.reportBtnText = 'Exporting...';

      this.$toasted.info('Exporting survey responses', {
        duration: 4000,
        position: 'top-right',
      });

      const questionsWithResponses = new Array(...this.questionsWithResponses);
      const data = [];
      const QUESTION_LENGTH_LIMIT = 14;

      // First sheet is the program users that have responded to the survey
      const programUsers = await this.$store.dispatch('getProgramUsers', { progid: this.activeCompanyProgram.id }).then((users) => {
        return users.map((user) => {
          const hasResponded = questionsWithResponses.some((questionWithResponses) => {
            return questionWithResponses.responses.some((response) => response.user.id == user.id);
          });

          return {
            ...user,
            hasResponded,
          };
        });
      });

      const programUsersData = {
        sheet: 'Program Users',
        content: programUsers,
        columns: [
          { label: 'User', value: (row) => `${row.name} ${row.last_name}` },
          { label: 'User email', value: (row) => row.email },
          { label: 'User type', value: (row) => (row.type == this.$store.state.User.accountTypes.mentor ? 'mentor' : 'mentee') },
          { label: 'Has taken survey', value: (row) => row.hasResponded ? 'Yes' : 'No' },
        ],
      };

      data.push(programUsersData);

      /**
       * a sheet = a survey question
       */
      questionsWithResponses.forEach((questionWithResponses, index) => {
        // eslint-disable-next-line no-underscore-dangle
        const _data = {
          sheet: `${index + 1} - ${questionWithResponses.type.q_type} - ${questionWithResponses.question.substring(0, QUESTION_LENGTH_LIMIT)}${questionWithResponses.question.length > QUESTION_LENGTH_LIMIT ? '...' : ''}`,
          content: questionWithResponses.responses,
        };

        if (questionWithResponses.type.q_type === 'Ratings') {
          const usersThatSelectedRating = (rating) => {
            const u = questionWithResponses.responses.map((response) => {
              if (response.rateid == rating.id) {
                return `${response.user.name} ${response.user.last_name}`;
              }
              return null;
            });

            return u.filter((u) => u !== null).reduce((acc, curr) => {
              return `${acc},\n ${curr}`;
            }, '');
          };

          _data.columns = questionWithResponses.ratings.map((rating) => ({
            label: rating.ratings,
            value: (row) => `${questionWithResponses.data[`${rating.ratings}/${rating.id}`]?.counts || 0} (${questionWithResponses.data[`${rating.ratings}/${rating.id}`]?.countPercentage || '0%'}) - \n${usersThatSelectedRating(rating)}`,
          }));
        } else if (questionWithResponses.type.q_type === 'Choices') {
          _data.columns = [
            { label: 'User', value: (row) => `${row.user.name} ${row.user?.middle || ''} ${row.user.last_name}` },
            { label: 'User email', value: (row) => row.user.email },
            // eslint-disable-next-line eqeqeq
            { label: 'User type', value: (row) => (row.user.type == this.$store.state.User.accountTypes.mentor ? 'mentor' : 'mentee') },
            { label: 'Selected choices', value: (row) => (questionWithResponses.userChoices[row.user.id]?.choices || []).map((choice) => choice.ratings).join(', ') },
          ];
        } else {
          _data.columns = [
            { label: 'User', value: (row) => `${row.user.name} ${row.user?.middle || ''} ${row.user.last_name}` },
            { label: 'User email', value: (row) => row.user.email },
            // eslint-disable-next-line eqeqeq
            { label: 'User type', value: (row) => (row.user.type == this.$store.state.User.accountTypes.mentor ? 'mentor' : 'mentee') },
            { label: 'Response', value: 'response' },
          ];
        }

        data.push(_data);
      });

      const today = new Date().toLocaleDateString('en-us', {
        weekday: 'long', year: 'numeric', month: 'short', day: 'numeric',
      });

      const settings = {
        fileName: `${this.activeCompanyProgram.name} program ${this.surveyType.name} survey responses [${today}]`,
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        alignment: {
          wrapText: true,
        },
        compression: false,
      };

      // eslint-disable-next-line no-unused-vars
      xlsx(data, settings, (e) => {
        // console.log('complete!', e);
      });

      this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.exportSurveyResponses);

      this.disabledReportBtn = false;
      this.reportBtnText = 'Export';
    },
  },
  async created() {
    await this.getCompany();
    await this.$nextTick();

    // assert user company permissions
    if (!this.hasPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getCompanyProgram();

    if (!this.hasProgramPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getPageData();

    await this.$nextTick();

    return true;
  },
};
</script>

<style>

</style>
